/*
 *
 *  * *****************************************************************************
 *  *  Copyright (C) 2020 Testsigma Inc.
 *  *  All rights reserved.
 *  *  ****************************************************************************
 *
 */

import { custom, deserialize, serializable } from 'serializr';
import { FilterOperation } from '../enums/filter.operation.enum';
import { TestCaseStatus } from '@testsigmainc/constants';
import { ResultConstant } from '../enums/result-constant.enum';
import { Base } from './base.model';
import { Deserializable } from './deserializable';

export class FilterQuery extends Base implements Deserializable {
  @serializable
  public key: string;
  @serializable
  public operation: FilterOperation;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public value:
    | boolean
    | number
    | string
    | Date
    | number[]
    | string[]
    | TestCaseStatus[]
    | ResultConstant[];

  public isTextFilter: boolean = false;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(FilterQuery, input));
  }
}
